export default __webpack_public_path__ + "static/media/GardenView_2.bc50d925.png";